import {template} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import RadioButton from 'src/components/radio-button';
import Text from 'shared/components/text';

class SchoolRadioButton extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
    school: PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      student_images: PropTypes.any,
      studentsOnRaise: PropTypes.any,
    }),
    labelTemplate: PropTypes.string.isRequired,
    cy: PropTypes.string,
  };

  render() {
    const {school, selected, onSelect, labelTemplate} = this.props;
    const hasStudentsOnRaise = school.studentsOnRaise > 0;
    const label = (
      <span
        className="school-radio-button-list-element-label"
        dangerouslySetInnerHTML={{__html: template(labelTemplate)(school)}}
      />
    );

    return (
      <div className="school-radio-button-list-element">
        <RadioButton
          cy={this.props.cy}
          label={label}
          checked={selected}
          onChange={() => {
            onSelect(school);
          }}
          name="school"
          value={school.id}
        />
        {hasStudentsOnRaise && (
          <div className="school-radio-button-students">
            <Text color="darkgrey" weight={5}>
              {`${school.studentsOnRaise} student${school.studentsOnRaise === '1' ? '' : 's'}`}
            </Text>
          </div>
        )}
      </div>
    );
  }
}

export default SchoolRadioButton;
